import { render, staticRenderFns } from "./automaticCallTransfer.vue?vue&type=template&id=3a118ce6&scoped=true"
import script from "./automaticCallTransfer.vue?vue&type=script&lang=js"
export * from "./automaticCallTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a118ce6",
  null
  
)

export default component.exports